module.exports = "<h2>\n  <span class=\"point no-margin\" [ngStyle]=\"{background: color}\"></span>\n\n  Activators Logic\n</h2>\n\n<ul class=\"feature oneline\">\n  <li *ngFor=\"let key of objectKeys(activators)\" style=\"height: 90px\">\n    <park-activator-logic-control [activator]=\"activators[key]\" [activatorId]=\"key\" [parkId]=\"parkId\" [id]=\"id\"></park-activator-logic-control>\n  </li>\n</ul>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/dashboard/parks/park/controls/features/activators-logic/park-activator-logic-controls.html
// module id = ./src/app/dashboard/parks/park/controls/features/activators-logic/park-activator-logic-controls.html
// module chunks = main